import { APPLICATION_PROPOSAL_CURRENCY_OPTIONS } from '../../../../config/constants'

export function proposalCurrencyOptions(calculationCurrency?: string | null): string[] {
  const codes = [ ...APPLICATION_PROPOSAL_CURRENCY_OPTIONS ]
  const extra = (calculationCurrency || '').trim()
  if (extra && !codes.includes(extra as ProposalCurrencyCode)) {
    return [ extra, ...codes ]
  }
  return codes
}

export function defaultProposalCurrencyCode(calculationCurrency?: string | null): string {
  const extra = (calculationCurrency || '').trim()
  if (extra) {
    return extra
  }
  return 'USD'
}
